import React, { useRef, useState } from "react";
import Layout from "../Common/Layout";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const OutboundChallan = () => {
    const formRef = useRef();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        noIrc: "8004",
        messers: "Aditya Birla",
        date: "2024-09-10",
        lorryNo: "NL01A-5950",
        cnNo: "331",
        dated: "2024-09-10",
        containing: "200 Bags Red Lentils",
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        toast.success("Printing is done.", {
            position: "top-right",
            autoClose: 1500,
            theme: "colored",
        });

        setTimeout(() => {
            navigate("/");
        }, 2500);
    }

    const handlePrint = () => {
        const printContents = formRef.current.innerHTML;
        const printWindow = window.open("", "_blank", "width=900,height=650");
        printWindow.document.open();
        printWindow.document.write(`
        <html>
            <head>
                <title>Print CRD</title>
                <style>
                    body { font-family: Arial; padding: 20px; }
                    table { width: 100%; border-collapse: collapse; }
                    table td, table th { border: 1px solid #000; padding: 6px; }
                    h2, h3 { text-align: center; }
                </style>
            </head>
            <body>${printContents}</body>
        </html>
    `);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
    };

    return (
        <Layout>
            <div className="container py-4">
                <div className="text-center mb-2">  <Link style={{ color: "white", marginLeft:"11rem"}} to="/dashboard" className='btn btn-primary'>Dashboard</Link></div> 
                {/* ================= FORM ================= */}
                <div className="card p-4 mb-4 shadow-sm" style={{width:"38rem",marginLeft:"22rem",display:"flex",justifyContent:"center"}}>
                    <h3 className="text-center mb-3">Outward Challan Form</h3>

                    <form action="">
                        <div className="row g-3">
                            <div className="col-md-4">
                                <label className="form-label">No. IRC</label>
                                <input
                                    type="text"
                                    name="noIrc"
                                    className="form-control"
                                    value={formData.noIrc}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label">Date</label>
                                <input
                                    type="date"
                                    name="date"
                                    className="form-control"
                                    value={formData.date}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="col-md-12">
                                <label className="form-label">Messers</label>
                                <input
                                    type="text"
                                    name="messers"
                                    className="form-control"
                                    value={formData.messers}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label">Lorry Number</label>
                                <input
                                    type="text"
                                    name="lorryNo"
                                    className="form-control"
                                    value={formData.lorryNo}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label">C/N Number</label>
                                <input
                                    type="text"
                                    name="cnNo"
                                    className="form-control"
                                    value={formData.cnNo}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="col-md-4">
                                <label className="form-label">Dated</label>
                                <input
                                    type="date"
                                    name="dated"
                                    className="form-control"
                                    value={formData.dated}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="col-md-8">
                                <label className="form-label">Containing</label>
                                <input
                                    type="text"
                                    name="containing"
                                    className="form-control"
                                    value={formData.containing}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>


                  

                    </form>
                </div>


                {/* ================= PREVIEW ================= */}
                {/* ref start */}

                <div ref={formRef}>
                    <div
              
                    className="p-4 border rounded shadow"
                    style={{ width: "700px", margin: "auto", background: "#fff", marginLeft:"18rem"}}
                >
                    <h3 className="text-center fw-bold mb-1">IRC LIMITED</h3>
                    <p className="text-center mb-0" style={{ fontSize: "13px" }}>
                        Regd. Office: 1, Sunyat Sen Street, Kolkata - 700 012 <br />
                        Phone : (033) 2236-5110 (5 Lines), Fax: (033) 2225-5936, E-mail : ho@ircl.in
                    </p>

                    <hr />

                    <div className="d-flex justify-content-between">
                        <p><strong>No. IRC:</strong> {formData.noIrc}</p>
                        <p><strong>Date:</strong> {formData.date}</p>
                    </div>

                    <p><strong>Messrs:</strong> {formData.messers}</p>

                    <p><strong>Dear Sirs,</strong></p>

                    <p>
                        We are sending <strong>Lorry No:</strong> {formData.lorryNo} to delivery{" "}
                        <strong>C/N No:</strong> {formData.cnNo}
                    </p>

                    <p>
                        Dated <strong>{formData.dated}</strong> containing{" "}
                        <strong>{formData.containing}</strong>
                    </p>

                    <p className="mt-4">
                        Kindly acknowledge receipt of material and hand over the relevant consignee copy
                        to the bearer.
                    </p>

                    <p className="mt-4">Thanking You,</p>

                    <div className="text-end mt-5">
                        <p className="fw-bold">IRC LIMITED</p>
                        <p>Despatching Officer</p>
                    </div>
                </div>
                </div>
                {/* ref end */}
                  <div className="text-center mb-5 mt-2 ">
                    <button className="btn btn-primary" onClick={handlePrint} style={{ color: "white", marginLeft:"10rem"}}>
                        Print CDD Challan
                    </button>
                </div>
            </div>
        </Layout>
    );
};

export default OutboundChallan;
